import React from "react";
import {connect} from "react-redux";
import {IApplicationState} from "../../store";
import {answerQuestion, leaveFeedback, leaveQuestion, showQuestion} from "../../store/questions/actions";
import {getQuestionHints} from "../../store/hints/types";
import {AnimatedQuestionScene} from "./AnimatedQuestionScene";
import {trackError} from "../../store/log/actions";
import {trackAction} from "../../store/common/actions";
import {showTutorial} from "../../store/tutorial/actions";

export default
    connect(({ player, game, hints, questions, settings }: IApplicationState) => {
        const progress = questions.progress[questions.currentQuestionId];
        const isTimeoutExpired = progress?.isTimeoutExpired || false;
        const isAnswered = progress?.attempts < 0 || isTimeoutExpired || false;

        return {
            lives: player.lives,
            levelInProgress: game.levelInProgress,
            question: game.questions[questions.currentQuestionId],
            answers: game.answers,
            authors: game.authors,
            progress: progress,
            isTimeoutExpired: isTimeoutExpired,
            resetTime: progress && progress.resetTime,
            isAnswered: isAnswered,
            categories: game.categories,
            appliedHints: getQuestionHints(hints.appliedHints, questions.currentQuestionId),
            secondsForAnswer: settings.gameBalance.secondsForAnswer,
            randomSeed: settings.randomSeed ^ questions.currentQuestionId,
            animation: settings.animation,
            shareImageApiEndpoint: settings.social.shareImageApiEndpoint,
            shareImageTemplate: settings.social.shareImageTemplate,
            shareTracking: settings.social.shareQuestionTracking,
            avatar: player.picture,
        };
    }, {
        showQuestion,
        leaveQuestion,
        answerQuestion,
        trackError,
        trackAction,
        showTutorial: showTutorial.request,
        leaveFeedback,
    })(AnimatedQuestionScene);